import React from 'react';
import './Modal.scss';
import { CloseIcon } from '../svg/index';

interface CancelModalProps {
  isOpen: boolean;
  close: () => void;
  confirm: () => void;
  message: string; 
  title: string; 
  buttonText: string; 
}

const CancelModal: React.FC<CancelModalProps> = ({ isOpen, close, confirm, message, title, buttonText }) => {
  if (!isOpen) return null;

  return (
    <div className='modal'>
        <div className='modal-content'>
            <div className='text-wrapper'>
                <div className="header-wrapper">
                    <h2 className="header">{title}</h2>
                    <button className="close-icon" onClick={close}>
                        <CloseIcon />
                    </button>
                </div>
                <p className="text"> {message} </p>
            </div>
            
            <div className='button-wrapper'>
                <auro-button variant="secondary" fluid onClick={close}>
                    <span className="btnlabel-blue">No</span>
                </auro-button>

                <auro-button variant="primary" fluid onClick={confirm}>
                    <span className="btnlabel-white">{buttonText}</span>
                </auro-button>
            </div>
        </div>
    </div>
  );
}

export default CancelModal;